import { createRouteRef } from '@backstage/core-plugin-api';

/**
 * Root route for the AI Assistant plugin
 */
export const rootRouteRef = createRouteRef({
  id: 'ai-assistant',
});
